<template>
  <div class="admin-tab-content">
    <div class="tab-header">
      <h2>👁️ Platinum Eyes</h2>
      <p class="description">Consulta y ajusta los Platinum Eyes de un usuario</p>
    </div>

    <!-- Search Section -->
    <div class="search-section">
      <div class="control-section">
        <label for="pe-search-type">Buscar por:</label>
        <select id="pe-search-type" v-model="searchType" class="admin-select">
          <option value="uid">UID</option>
          <option value="email">Email</option>
          <option value="username">Usuario</option>
        </select>
      </div>

      <div class="control-section">
        <label for="pe-search-query">{{ searchLabel }}:</label>
        <div class="search-input-wrapper">
          <input
            type="text"
            id="pe-search-query"
            v-model="searchQuery"
            @keyup.enter="searchUser"
            class="admin-input"
            :placeholder="`Ingrese ${searchLabel.toLowerCase()}`"
          />
          <button @click="searchUser" class="btn-primary" :disabled="searching">
            {{ searching ? 'Buscando...' : 'Buscar' }}
          </button>
        </div>
      </div>
    </div>

    <!-- User Info & Platinum Eyes -->
    <div v-if="userInfo" class="pe-section">
      <h3>Usuario</h3>
      <div class="info-card">
        <p><strong>UID:</strong> {{ userInfo.uid }}</p>
        <p><strong>Nombre:</strong> {{ userInfo.name }}</p>
        <p><strong>Email:</strong> {{ userInfo.mail }}</p>
      </div>

      <div class="pe-stats">
        <div class="pe-stat">
          <span class="pe-stat-label">Platinum Eyes (total)</span>
          <span class="pe-stat-value">{{ platinumEyes }}</span>
        </div>
        <div class="pe-stat">
          <span class="pe-stat-label">Platinum Eyes restantes</span>
          <span class="pe-stat-value">{{ platinumEyesRemaining }}</span>
        </div>
      </div>

      <div class="adjust-form">
        <h4>Ajustar Platinum Eyes restantes</h4>
        <div class="edit-controls">
          <select v-model="operation" class="admin-select">
            <option value="set">Establecer</option>
            <option value="add">Añadir</option>
            <option value="consume">Consumir</option>
          </select>
          <input
            type="number"
            class="admin-input"
            min="0"
            v-model.number="value"
            placeholder="Cantidad"
          />
          <button @click="save" class="btn-primary" :disabled="saving || !canSave">
            {{ saving ? 'Guardando...' : 'Guardar' }}
          </button>
        </div>
        <p class="help-text">
          - Establecer: fija el número exacto. Añadir: suma a los restantes. Consumir: resta de los restantes.
        </p>
      </div>
    </div>

    <div v-if="message" :class="['message-box', messageType]">
      {{ message }}
    </div>
  </div>
  
</template>

<script>
import axios from 'axios';

export default {
  name: 'PlatinumEyesTab',
  data() {
    return {
      searchType: 'uid',
      searchQuery: '',
      searching: false,
      saving: false,
      userInfo: null,
      platinumEyes: 0,
      platinumEyesRemaining: 0,
      operation: 'set',
      value: 0,
      message: '',
      messageType: ''
    };
  },
  computed: {
    searchLabel() {
      if (this.searchType === 'uid') return 'UID';
      if (this.searchType === 'email') return 'Email';
      return 'Usuario';
    },
    canSave() {
      return this.userInfo && this.value >= 0 && this.operation;
    }
  },
  methods: {
    async searchUser() {
      const q = (this.searchQuery || '').trim();
      if (!q) {
        this.showMessage('Por favor ingrese un valor de búsqueda', 'error');
        return;
      }

      this.searching = true;
      this.message = '';
      this.userInfo = null;
      this.platinumEyes = 0;
      this.platinumEyesRemaining = 0;

      try {
        const response = await axios.get(`${process.env.VUE_APP_API}/adminmenu/user-features/lookup`, {
          params: { query: q, type: this.searchType }
        });

        if (response.data.success) {
          this.userInfo = response.data.user;
          const features = response.data.features || {};
          const consumibles = features.consumibles || {};
          this.platinumEyes = consumibles.platinum_eyes || 0;
          this.platinumEyesRemaining = consumibles.platinum_eyes_remaining || 0;
        } else {
          this.showMessage(response.data.message || 'Usuario no encontrado', 'error');
        }
      } catch (e) {
        this.showMessage('Error al buscar usuario', 'error');
      } finally {
        this.searching = false;
      }
    },
    async save() {
      if (!this.canSave) return;
      this.saving = true;
      this.message = '';

      try {
        const response = await axios.post(`${process.env.VUE_APP_API}/adminmenu/user-features/update`, {
          uid: this.userInfo.uid,
          feature: {
            key: 'platinum_eyes_remaining',
            value: this.value,
            type: 'consumibles',
            operation: this.operation
          }
        });

        if (response.data.success) {
          this.showMessage('Platinum Eyes actualizados correctamente', 'success');
          await this.searchUser();
          this.value = 0;
          this.operation = 'set';
        } else {
          this.showMessage(response.data.message || 'Error al actualizar', 'error');
        }
      } catch (e) {
        this.showMessage('Error al guardar', 'error');
      } finally {
        this.saving = false;
      }
    },
    showMessage(msg, type) {
      this.message = msg;
      this.messageType = type;
      if (type === 'success') {
        setTimeout(() => { this.message = ''; }, 3000);
      }
    }
  }
};
</script>

<style scoped>
.admin-tab-content {
  padding: 20px;
}

.tab-header h2 {
  color: #3498db;
  font-size: 24px;
  margin-bottom: 10px;
}

.description {
  color: #bbb;
  margin-bottom: 30px;
}

.search-section {
  background: #2c2c2c;
  padding: 20px;
  border-radius: 6px;
  margin-bottom: 20px;
}

.control-section {
  margin-bottom: 15px;
}

.control-section label {
  display: block;
  font-weight: 500;
  margin-bottom: 8px;
  color: #e6e6e6;
}

.search-input-wrapper {
  display: flex;
  gap: 10px;
}

.admin-input {
  background-color: #333;
  border: 1px solid #444;
  border-radius: 4px;
  color: #fff;
  font-size: 14px;
  height: 38px;
  padding: 0 10px;
  flex: 1;
}

.admin-select {
  background-color: #333;
  border: 1px solid #444;
  border-radius: 4px;
  color: #fff;
  font-size: 14px;
  height: 38px;
  padding: 0 10px;
  min-width: 150px;
}

.pe-section {
  background: #2c2c2c;
  padding: 20px;
  border-radius: 6px;
}

.info-card {
  background: #333;
  padding: 15px;
  border-radius: 4px;
  border-left: 3px solid #3498db;
  margin-bottom: 20px;
}

.info-card p {
  margin: 8px 0;
  color: #e6e6e6;
}

.pe-stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 12px;
  margin-bottom: 20px;
}

.pe-stat {
  background: #333;
  padding: 12px 15px;
  border-radius: 4px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.pe-stat-label {
  color: #e6e6e6;
}

.pe-stat-value {
  color: #f1c40f;
  font-weight: 600;
}

.adjust-form {
  background: #333;
  padding: 15px;
  border-radius: 4px;
  border-left: 3px solid #8e44ad;
}

.adjust-form h4 {
  color: #8e44ad;
  font-size: 16px;
  margin-bottom: 15px;
}

.edit-controls {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.btn-primary {
  background: #3498db;
  border: none;
  border-radius: 4px;
  color: white;
  cursor: pointer;
  font-size: 14px;
  padding: 10px 20px;
  transition: all 0.2s ease;
}

.btn-primary:hover:not(:disabled) {
  background: #2980b9;
  transform: translateY(-1px);
}

.btn-primary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.help-text {
  color: #aaa;
  font-size: 13px;
  margin-top: 8px;
}

.message-box {
  background-color: #333;
  border-radius: 4px;
  margin-top: 15px;
  padding: 10px;
  border-left: 3px solid #3498db;
}

.message-box.success {
  border-left-color: #2ecc71;
  color: #2ecc71;
}

.message-box.error {
  border-left-color: #e74c3c;
  color: #e74c3c;
}
</style>


